<div class="section-main-card">
  <div class="involvement-table-wrapper">
    <table class="involvement-table">
      <thead>
        <tr>
          <th>Involvement</th>
          <th>Details</th>
        </tr>
      </thead>

      <ng-container *ngFor="let group of card.groups">
        <tbody>
          <tr *ngFor="let row of group.rows; let i = index">
            <!-- Only render the category cell for the first row, with rowspan -->
            <td *ngIf="i === 0" [attr.rowspan]="group.rows.length">
              {{ group.category }}
            </td>
            <td>
              <span *ngIf="row.formatted" [innerHTML]="row.formatted | markdown">
              </span>
            </td>
          </tr>
        </tbody>
      </ng-container>
    </table>
  </div>
</div>
